const TR_MONTHS = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
];
const TR_DAYS_SHORT = ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"];

function pad(n) {
  return String(n).padStart(2, "0");
}

export function monthKey(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}`;
}

export function localDateString(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function getTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "UTC";
  }
}

export function getTimezoneOffset() {
  // Browser returns minutes-from-UTC inverted (e.g. UTC+3 → -180). Mobile contract sends this as-is.
  return new Date().getTimezoneOffset();
}

export function parseLocalDate(s) {
  if (!s || typeof s !== "string") return null;
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const [, y, mo, d] = m;
  const date = new Date(Number(y), Number(mo) - 1, Number(d));
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatTurkishDate(date) {
  const day = TR_DAYS_SHORT[date.getDay()];
  return `${date.getDate()} ${TR_MONTHS[date.getMonth()]} ${date.getFullYear()} ${day}`;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function daysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

// Returns 0-based weekday index Mon..Sun (Mon=0, Sun=6) for week-starts-on-Monday calendars.
export function mondayIndex(date) {
  const dow = date.getDay(); // 0=Sun..6=Sat
  return (dow + 6) % 7;
}

/** "3 Eyl 2026" biçiminde kısa tarih; geçersiz değerde "—". */
export function formatShortDate(value) {
  if (!value) return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()} ${TR_MONTHS[d.getMonth()].slice(0, 3)} ${d.getFullYear()}`;
}
